<template>
    <div class="edit-detail layout-sub-page">
        <div class="title-bar dsp-flex">
            <div class="title-side title-gray">
                <i class="iconfont icon-xiangzuo" @click="clickBack"></i>
            </div>
            <div class="title-middle">编辑</div>
            <div class="title-side title-right" @click="clickSave">
                <button class="title-button" v-bind:class="{'title-button-gray': !editedStatus}" v-bind:disabled="!editedStatus">保存</button>
            </div>
        </div>
        <div class="detail-content edit-detail-content">
            <!-- 1. 命盘部分 -->
            <fate-panel 
                v-bind:hideSideBar="true" 
                v-bind:fateData="editFateListData" 
                v-bind:fateInfo="editFateInfo">
            </fate-panel>

            <!-- 2. 编辑修改部分 -->
            <div class="edit-detail-form">
                <collate-form 
                    v-bind:parentNode="parentNode" 
                    v-bind:chooseGroupFunc="clickChooseGroup" 
                    v-bind:personData="editPersonInfo"
                    v-bind:chooseLabelFunc="clickChooseLabel">
                </collate-form>
            </div>
        </div>
        <!-- 3. 选择地址组件 -->
        <van-overlay v-show="showArea" @click="clickShowAreaOverlay" />
        <vant-area v-show="showArea" v-bind:parentNode="parentNode"></vant-area>

        <!-- 4. 输入生日日期组件 -->
        <van-popup v-bind:value="showBirthday" position="bottom" @click-overlay="clickShowBirthdayOverlay">
            <input-birthday-panel
                v-bind:parentNode="parentNode">
            </input-birthday-panel>
        </van-popup>

        <router-view></router-view>
    </div>
</template>
<script>
import FatePanel from '../../layouts/panel/FatePanel.vue'
import CollateForm from '../../layouts/collate/CollateForm.vue'
import VantArea from '../../layouts/vant/VantArea.vue'
import InputBirthdayPanel from '../../components/InputBirthdayPanel.vue'
import { MIX } from '../../modules/utils';

export default {
    name: 'EditDetail',
    components: { FatePanel, CollateForm, VantArea, InputBirthdayPanel},
    computed: {
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
        showArea () {
            return this.$store.state.collate.showArea;
        },
        showBirthday() {
            return this.$store.state.collate.showBirthday;
        },
        editPersonInfo() {
            return this.$store.state.edit.editPersonInfo;
        },
        editFateInfo() {
            return this.$store.state.edit.editFateInfo;
        },
        editFateListData() {
            var editFateListData = [].concat(this.$store.state.edit.editFateListData);
                editFateListData = parseInt(this.settingConfigData.nianyueRishi) == 0 ? editFateListData : editFateListData.reverse();
            return editFateListData;
        },
        editedStatus() {
            return this.$store.state.edit.editedStatus;
        }
    },
    data() {
        return {
            parentNode: {'name': 'EditDetail'},
            titleData: {'titleText': '编辑', 'titleCreate': '保存', 'showCancel': false},
        }
    },
    beforeCreate: function() {
        if(!this.$store.state.detail.personInfo.id){
            this.$router.replace('/record');
        }
    },
    mounted: function() {
        setTimeout(() => {
            this.initDom();
            this.$store.dispatch('initTimeInputData', {time: this.editPersonInfo.birthday, from: 'edit_detail'})
            MIX.trackPageViewed('EditBZInfo');
        }, 100);
    },
    methods: {
        initDom() {
            // 重置编辑页内容的高度
            var titleDiv = document.getElementsByClassName('title-bar')[0],
                contentDiv = document.getElementsByClassName('edit-detail-content')[0];
            if(contentDiv) {
                contentDiv.style.paddingTop = titleDiv.clientHeight + 'px';
            }
            // 重置编辑页命盘的样式
            var fateDiv = document.getElementsByClassName('layout-detail-fate')[0];
            if(fateDiv) {
                fateDiv.className = "layout-detail-fate edit-detail-fate dsp-flex";
            }
        },
        clickShowAreaOverlay() {
            this.$store.state.collate.showArea = false;
        },
        clickShowBirthdayOverlay() {
            this.$store.state.collate.showBirthday = false;
            this.$bus.emit('resetIPBPKeyBoard');
        },
        clickChooseGroup() {
            // 非一级页面要用push的方式
            var detailInfo = this.$store.state.detail.personInfo,
                params = this.$router.history.current.params.from;
                params = params ? params : 'record'; 
            this.$router.replace('/edit/'+params+'/'+detailInfo.id+'/choosegroup');
        },
        clickChooseLabel() {
            var detailInfo = this.$store.state.detail.personInfo,
                params = this.$router.history.current.params.from;
                params = params ? params : 'record'; 
            this.$router.replace('/edit/'+params+'/'+detailInfo.id+'/label');
        },
        clickBack() {
            // 二次确认
            var me = this;
            var detailInfo = this.$store.state.detail.personInfo;
            // console.error('clickBack------', detailInfo);
            if(this.$store.state.edit.editedStatus){
                this.$dialog.confirm({
                    message: '是否要保存修改？',
                    confirmButtonText: '保存',
                    cancelButtonText: '不保存'
                }).then(() => {
                    // 触发保存
                    me.$store.dispatch('edit/saveEditDetail');
                }).catch(() => {
                    // 返回上一页并重置数据
                    me.backPage();
                    me.$store.dispatch('collate/resetData')
                    me.$store.dispatch('edit/resetData')
                    me.$store.dispatch('group/resetChooseGroupData')
                });
            }else{
                // 返回上一页并重置数据
                me.backPage();
                me.$store.dispatch('collate/resetData')
                me.$store.dispatch('edit/resetData')
                me.$store.dispatch('group/resetChooseGroupData')
            }
        },
        backPage() {
            // 处理跳转页面
            var path = this.$router.history.current.path;
            path = path.replace('edit', 'detail');
            this.$router.replace(path);
        },
        clickSave() {
            if(this.$store.state.edit.editedStatus) {
                this.$store.dispatch('edit/saveEditDetail');
            }else{
                this.$toast("未检测到修改");
            }
        }

    }

}
</script>